import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var AssetGroupService = /** @class */ (function () {
    function AssetGroupService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    AssetGroupService.prototype.find = function () {
        var api = _GlobalNS.api.partner.relationshipGroupById;
        return this._http.get("" + api, {});
    };
    // Logged in PersonId is used for this service, not passing personid param expicilty
    AssetGroupService.prototype.findMasterByPerson = function () {
        var api = _GlobalNS.api.user.relationshipGroupByPerson;
        return this._http.get("" + api, {});
    };
    // Logged in PersonId is used for this service, not passing personid param expicilty
    AssetGroupService.prototype.findByPerson = function () {
        var api = _GlobalNS.api.user.relationshipGroupByPerson;
        return this._http.get(api + "&groupOnly=true", {});
    };
    AssetGroupService.prototype.remove = function (relationshipGroupId) {
        var api = _GlobalNS.api.partner.deleteRelationshipGroup;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&RelationshipGroupId=" + relationshipGroupId + "&eqrf=" + eqrf, this.httpOptions);
    };
    AssetGroupService.prototype.create = function (relationshipGroup) {
        var api = _GlobalNS.api.partner.relationshipGroup;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, relationshipGroup, this.httpOptions);
    };
    AssetGroupService.prototype.assetGroupNameExists = function (RelationshipGroupName, relationshipId) {
        var api = _GlobalNS.api.partner.assetGroupNameExists;
        var params = new HttpParams().set('RelationshipGroupName', RelationshipGroupName).set('relationshipId', relationshipId.toString());
        return this._http.get("" + api, { params: params });
    };
    AssetGroupService.ngInjectableDef = i0.defineInjectable({ factory: function AssetGroupService_Factory() { return new AssetGroupService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: AssetGroupService, providedIn: "root" });
    return AssetGroupService;
}());
export { AssetGroupService };
